export class ProductScireum {

  constructor(
    public isNew?: boolean,
    public sale?: boolean,
    public clearance?: boolean,
    public isNotOrderable?: boolean,
    public hidden?: boolean,
    public stockItem?: boolean,
    public exportable?: boolean,
    public specialistRetailer?: boolean,
    public series?: string,
    public extendedKeyword?: string,
    public configuratorLink?: string,
    public ranking?: number,
    public oxomiHausmarkennummer?: string,
    public nordwestArtikelnummer?: string,
    public abweichendeLieferantennummer?: string ,
    public zusaetzlicherMatchCode?: string,
    public katalogartikelnummer?: string,
    public empfohleneMenge?: number,
    public befoerderungskategorie?: number,
    public artikellaengeMM?: number,
    public artikelbreiteMM?: number,
    public artikelhoeheMM?: number,
    public artikeltiefeMM?: number,
    public artikelGewichtKG?: number ,
    public volumen?: number,
    public warennummer?: string,
    public nurGewerblich?: boolean,
    public lithiumbatterieEnthalten?: boolean ,
    public enthaeltElektrischeKomponenten?: boolean ,
    public ceKennzeichnung?: boolean ,
    public echadbhinterlegt?: boolean ,
    public ubaListKonform?: boolean ,
    public gefahrengutKlasse?: string ,
    public unNummer?: number,
    public offizielleBezeichnung?: string,
    public technischeBezeichnung?: string,
    public versandbezeichnung?: string,
    public gefahrenzettel?:string,
    public gefahrgutVerpackungsgruppe?: string,
    public anzahlGefahrgutVersandstuecke?: number,
    public beschreibungGefargutVersandstuecke?: string,
    public befoerderungskategorieGefahrgut?: number,
    public batteriepiktogramm?: number,
    public handelsname?: string,
    public brandPageLink?:string,
    public enthaeltHazardGoods: boolean = false
    
  ) {
  }
}

